import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addUser } from '../config/Actions'

export default function UserAdd() {
    const [user , setUser] = useState({})
    const users = useSelector(state=>state.users)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleChange = (e)=>{ 
        setUser({...user, id:users.length+1,[e.target.name] : e.target.value})
    }
  return (
    <div>
        <form className='w-50 ms-5 bg-dark text-light p-5'>
{/*             <div className='form-group'>
            <label className='form-label'>ID :</label>
           <input className='form-control' name='id' type='text' value={user.id}  disabled/>       
            </div> */}
            <div className='form-group'>
            <label className='form-label'>First Name :</label>
           <input className='form-control' name='firstName' type='text' onChange={handleChange} value={user.firstName} />       
            </div>
            <div className='form-group'>
            <label className='form-label'>Last Name :</label>
           <input className='form-control' name='lastName' type='text' onChange={handleChange} value={user.lastName} />       
            </div>
            <div className='form-group'>
            <label className='form-label'>Age :</label>
           <input className='form-control' name='age' type='text' onChange={handleChange} value={user.age} />       
            </div>
            <div className='form-group w-100'>
                <button className='btn btn-primary mt-3 w-100' type='button' onClick={()=>{dispatch(addUser(user));navigate('/')}}> Save </button>
            </div> 
        </form>
    </div>
  )
}
